import { supabase } from './supabaseClient';

export async function loadClubBranding(
  organisationId
) {
  const safeOrganisationId = String(
    organisationId || ''
  ).trim();

  if (!safeOrganisationId) {
    return {
      clubName: '',
      logoUrl: '',
      heroImages: [],
    };
  }

  const { data, error } = await supabase
    .from('club_branding')
    .select(
      'organisation_id, club_name, logo_url, hero_image_1, hero_image_2, hero_image_3, hero_image_4, hero_image_5'
    )
    .eq(
      'organisation_id',
      safeOrganisationId
    )
    .maybeSingle();

  if (error || !data) {
    return {
      clubName: '',
      logoUrl: '',
      heroImages: [],
    };
  }

  return {
    clubName: data.club_name || '',
    logoUrl: data.logo_url || '',
    heroImages: [
      data.hero_image_1,
      data.hero_image_2,
      data.hero_image_3,
      data.hero_image_4,
      data.hero_image_5,
    ].filter(Boolean),
  };
}